// /js/force-page-reload.js

document.addEventListener('DOMContentLoaded', function() {
    // Znajdź główny kontener paginacji
    const paginationContainer = document.querySelector('.wp-block-query-pagination');

    if (!paginationContainer) {
        return; // Jeśli nie ma paginacji, zakończ
    }

    // Funkcja, która usuwa "interaktywne" atrybuty z linków
    const makeLinksNormal = () => {
        const interactiveLinks = paginationContainer.querySelectorAll('a[data-wp-on--click]');

        interactiveLinks.forEach(link => {
            link.removeAttribute('data-wp-on--click');
            link.removeAttribute('data-wp-on--mouseenter');
            link.removeAttribute('data-wp-watch');
            // Możesz też usunąć inne atrybuty data-wp-* jeśli nadal będą problemy
        });
        console.log('Usunięto interaktywność WP i przywrócono normalne linki paginacji.');
    };

    // Uruchom funkcję od razu
    makeLinksNormal();

    // Ponieważ ten blok może się dynamicznie odświeżać,
    // ustawiamy MutationObserver, aby pilnował zmian i ponownie usuwał atrybuty.
    const observer = new MutationObserver((mutationsList) => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                makeLinksNormal();
            }
        }
    });

    observer.observe(paginationContainer, { childList: true, subtree: true });
});